import React, { useEffect } from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { STATIC_ROOT } from '../../../../constants';

import { validateCheckSms } from '../../../../services/ebon/actions';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';
import HeadComponent from '../../../HeadComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';

import './ConfirmationEbonSmsPage.scss';

const ConfirmationEbonSmsPage = ({ i18n, validateCheckSms, validSms, fetching }) => {
    useEffect(() => {
        let token = window.location.href.split('/');
        validateCheckSms(token[token.length - 1]);
    }, []);

    return (
        <main id="confirmation-sms" className="conteneur conteneur-mobile">
            <HeadComponent title={i18n.TITLE} description={i18n.DESCRIPTION} />

            {fetching && (
                <div className="content">
                    <LoadingComponent />
                </div>
            )}

            {!fetching && !isEmpty(validSms) && (
                <div className="content">
                    <SvgComponent
                        src={`${STATIC_ROOT}/icon/picto-valide.svg`}
                        width="60"
                        height="60"
                    />
                    <p>{i18n.TEXT_1}</p>
                    <span>
                        {convertHtmlToReactDomWithParams(
                            i18n.TEXT_2,
                            validSms.partnerName,
                            validSms.totalAmount
                        )}
                    </span>
                </div>
            )}

            {!fetching && isEmpty(validSms) && <div className="content">{i18n.ERROR}</div>}
        </main>
    );
};

ConfirmationEbonSmsPage.propTypes = {
    i18n: PropTypes.object
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.EBON.SMS_CONFIRMATION,
        validSms: state.ebon.validateSms,
        fetching: state.ebon.validateSmsFetching
    };
};

const mapDispatchToProps = {
    validateCheckSms
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConfirmationEbonSmsPage));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/sms/ConfirmationEbonSmsPage.js